var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardDifficult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#CA5050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 35H15.25C14.6533 35 14.081 34.7629 13.659 34.341C13.2371 33.919 13 33.3467 13 32.75V23.25C13 22.6533 13.2371 22.081 13.659 21.659C14.081 21.2371 14.6533 21 15.25 21H17.75C18.3467 21 18.919 21.2371 19.341 21.659C19.7629 22.081 20 22.6533 20 23.25V32.75C20 33.3467 19.7629 33.919 19.341 34.341C18.919 34.7629 18.3467 35 17.75 35ZM26.75 35H24.25C23.6533 35 23.081 34.7629 22.659 34.341C22.2371 33.919 22 33.3467 22 32.75V20.25C22 19.6533 22.2371 19.081 22.659 18.659C23.081 18.2371 23.6533 18 24.25 18H26.75C27.3467 18 27.919 18.2371 28.341 18.659C28.7629 19.081 29 19.6533 29 20.25V32.75C29 33.3467 28.7629 33.919 28.341 34.341C27.919 34.7629 27.3467 35 26.75 35ZM35.7275 35H33.2275C32.6308 35 32.0585 34.7629 31.6365 34.341C31.2146 33.919 30.9775 33.3467 30.9775 32.75V16.25C30.9775 15.6533 31.2146 15.081 31.6365 14.659C32.0585 14.2371 32.6308 14 33.2275 14H35.7275C36.3242 14 36.8965 14.2371 37.3185 14.659C37.7404 15.081 37.9775 15.6533 37.9775 16.25V32.75C37.9775 33.3467 37.7404 33.919 37.3185 34.341C36.8965 34.7629 36.3242 35 35.7275 35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDifficult);
export default __webpack_public_path__ + "static/media/hard-difficult.61424ccbb169583b4efd817677c2a049.svg";
export { ForwardRef as ReactComponent };